export class DataCatalogViewProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "query",
            "baseName": "query",
            "type": "DataCatalogViewQuery",
            "format": ""
        },
        {
            "name": "aiProperties",
            "baseName": "aiProperties",
            "type": "DataCatalogViewAiProperties",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogViewProperties.attributeTypeMap;
    }
    constructor() {
    }
}
